<template>
  <div id="app">
    <template v-if="user">
      <carrito-lateral 
        :carrito="carrito" 
        :mostrar="mostrarCarrito" 
        :user="user" 
        v-if="user.roles[0] === 'admincliente' || user.roles[0] === 'user'"
        @toggle-carrito="onToggleCarrito"
        @disminuir-cantidad="onDisminuirCantidadPlatoDia"
        @agregar-carrito="onAgregarCarrito"
        @mostrar-notificacion="onMostrarNotificacion"
        ></carrito-lateral>  
    </template>
    <keep-alive>
      <topbar :user="user" @toggle-carrito="onToggleCarrito" @try-logout="onTryLogout" :carrito="carrito" ></topbar> 
    </keep-alive>
    <router-view 
      @try-login="onTryLogin" 
      @toggle-carrito="onToggleCarrito"
      @esconder-carrito="onCerrarCarrito"
      @activar-modal="onActivarModal"
      @cerrar-modal="onCerrarModal"
      @agregar-carrito="onAgregarCarrito"
      @asignar-plato="onAsignarPlatoEmpleado"
      @desasignar-plato="onDesasignarPlatoProveedor"
      @disminuir-cantidad="onDisminuirCantidadPlatoDia"
      @mostrar-notificacion="onMostrarNotificacion"
      @vaciar-carrito="onVaciarCarrito"
      @try-logout="onTryLogout"
      @user-loggged="onUserLogged"
      @perfil-changed="onPerfilChanged"
      :carrito="carrito"
      :user="user"
      :maps-loaded="mapsLoaded"
    >
    </router-view>
    <div class="clearfix"></div>
    <footer class="footer white" style="border-top-width: 0px;">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ul class="social">
              <li><a href="https://www.facebook.com/andalepide" target="_blank"><i class="fa fa-facebook"></i></a></li>
              <li><a href="https://www.twitter.com/andalepide" target="_blank"><i class="fa fa-twitter" ></i></a></li>
              <li><a href="https://www.instagram.com/andalepide" target="_blank"><i class="fa fa-instagram"></i></a></li>
            </ul>
            <ul class="footer-links">
              <router-link tag="li" active-class="active" to="/faq"><a>Preguntas frecuentes</a></router-link>
              <router-link tag="li" active-class="active" to="/partners"><a>Partners</a></router-link>
              <router-link tag="li" active-class="active" to="/terminos"><a>Términos y Condiciones</a></router-link>
              <router-link tag="li" active-class="active" to="/privacidad"><a>Privacidad</a></router-link>
              <router-link tag="li" active-class="active" to="/contacto"><a>Contacto</a></router-link>
            </ul>
            <p class="copyright">© 2017 andalepide.com - Todos los derechos reservados</p>
          </div>  
        </div>
      </div>
    </footer>
    <div class="modal fade" ref="modalEspere" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Modal title</h4>
          </div> -->
          <div class="modal-body">
            <div class="text-center center-block">
              <img src="/images/bird.png" ref="pajarito" class="animation-target" alt="">
              <span>Procesando su petición</span>
              <span>Por favor no cierre el navegador</span>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
  </div>
</template>

<script>
import $ from 'jquery'
import NavIndex from './components/Navbar/NavIndex.vue'
import CarritoLateral from './components/Pedido/CarritoLateral'
import 'pace-progress'
import _ from 'lodash'
import 'noty/lib/noty.css'
import Noty from 'noty'
import mixinsCarrito from './mixins/Carrito.js'
import localforage from 'localforage'

export default {
  name: 'app',
  props: ['maps-loaded'],
  mixins: [mixinsCarrito],
  components: {
    'topbar': NavIndex,
    'carrito-lateral': CarritoLateral
  },
  data () {
    return {
      carrito: [],
      user: undefined,
      mostrarCarrito: false
    }
  },
  methods: {
    onCerrarCarrito () {
      this.mostrarCarrito = false
    },
    onDisminuirCantidadPlatoDia (dia, plato) {
      console.log('onDisminuirCantidadPlatoDia', dia, plato)
      const me = this
      let platoDia = me.getPlatoProveedorDia(dia, plato)
      if (platoDia) {
        if (platoDia.cantidad > 0) {
          platoDia.cantidad -= 1
        }
        let proveedor = me.getProveedorDia(dia, plato.proveedor)
        if (platoDia.cantidad === 0) {
          let idx = proveedor.platos.indexOf(platoDia)
          proveedor.platos.splice(idx, 1)
          if (proveedor.platos.length === 0) {
            let existeDia = me.existeDia(dia)
            let idxProveedor = existeDia.proveedor.indexOf(proveedor)
            existeDia.proveedor.splice(idxProveedor, 1)
          }
        }
      }
      let existeDia = me.carrito.find((itemCarrito) => {
        return itemCarrito.fecha === dia
      })
      if (existeDia) {
        let idx = this.carrito.indexOf(existeDia)
        if (idx > -1) {
          if (existeDia.proveedor.length === 0) {
            me.carrito.splice(idx, 1)
          } else {
            me.carrito.splice(idx, existeDia)
          }
        }
      }
    },
    existeAsignacionEnPlato (plato, idEmpleado) {
      if (!plato.asignaciones) return undefined
      let asignacion = plato.asignaciones.find((oAsignacion) => {
        return oAsignacion.idEmpleado === idEmpleado
      })
      return asignacion
    },
    existeDia (dia) {
      let elDia = this.carrito.find((item) => {
        return item.fecha === dia
      })
      return elDia
    },
    existePlatoEnProveedor (proveedor, plato) {
      let platoEnDia = proveedor.platos.find((platoProveedor) => {
        console.log(platoProveedor.plato._id === plato._id)
        return platoProveedor.plato._id === plato._id
      })
      return platoEnDia
    },
    existeProveedorEnDia (dia, idProveedor) {
      let proveedor = dia.proveedor.find((proveedorEnDia) => {
        return proveedorEnDia._id === idProveedor
      })
      return proveedor
    },
    onActivarModal (e) {
      $('html, body').animate({ scrollTop: 0 }, 'slow')
      $(this.$refs.modalEspere).modal()
    },
    onCerrarModal () {
      $(this.$refs.modalEspere).modal('hide')
    },
    checkearStock (check, cb) {
      this.$http.post('/api/platos/disponibilidad', check).then((response) => {
        console.log(response)
        cb(response.body.disponible)
      }, (error) => {
        console.log('err', error)
        cb(false)
      })
    },
    onAgregarCarrito (dia, plato, combo = null, reglas = []) {
      const me = this
      let checkStock = {plato: plato._id, fechaFormateada: dia.substring(0, 10)}
      let diaEnCarrito = me.existeDia(dia)
      if (diaEnCarrito) {
        let proveedorEnDia = me.existeProveedorEnDia(diaEnCarrito, plato.proveedor)
        if (proveedorEnDia) {
          let platoEnProveedor = me.existePlatoEnProveedor(proveedorEnDia, plato)
          if (platoEnProveedor) {
            checkStock.cantidad = platoEnProveedor.cantidad + 1
            me.checkearStock(checkStock, (disponible) => {
              if (disponible) {
                platoEnProveedor.cantidad += 1
              } else {
                me.onMostrarNotificacion('No se puede agregar el item al carrito, no hay stock disponible', 'error')
              }
            })
          } else {
            checkStock.cantidad = 1
            me.checkearStock(checkStock, (disponible) => {
              if (disponible) {
                let platoInsertar = {
                  cantidad: 1,
                  plato: plato
                }
                proveedorEnDia.platos.push(platoInsertar)
              } else {
                me.onMostrarNotificacion('No se puede agregar el item al carrito, no hay stock disponible', 'error')
              }
            })
          }
        } else {
          checkStock.cantidad = 1
          me.checkearStock(checkStock, (disponible) => {
            if (disponible) {
              let proveedor = {
                _id: plato.proveedor,
                precio: 100,
                platos: [{
                  plato: plato,
                  cantidad: 1
                }]
              }
              diaEnCarrito.proveedor.push(proveedor)
            } else {
              me.onMostrarNotificacion('No se puede agregar el item al carrito, no hay stock disponible', 'error')
            }
          })
        }
        let idx = me.carrito.indexOf(diaEnCarrito)
        console.log('idx', idx)
        if (idx > -1) {
          me.carrito.splice(idx, 1, diaEnCarrito)
        }
      } else {
        let itemCarrito = {
          fecha: dia,
          combo: combo,
          reglas: reglas,
          proveedor: [{
            _id: plato.proveedor,
            precio: 100,
            platos: [{
              plato: plato,
              cantidad: 1
            }]
          }]
        }
        me.carrito.push(itemCarrito)
      }
      me.mostrarCarrito = true
    },
    onAsignarPlatoEmpleado (options) {
      const me = this
      let itemCarrito = me.existeDia(options.fecha)
      let proveedor = me.existeProveedorEnDia(itemCarrito, options.plato.proveedor)
      let platoProveedor = me.existePlatoEnProveedor(proveedor, options.plato)
      let asignacion = me.existeAsignacionEnPlato(platoProveedor, options.idEmpleado)
      if (asignacion) {
        asignacion.cantidad += 1
      } else {
        if (platoProveedor.asignaciones) {
          platoProveedor.asignaciones.push({
            idEmpleado: options.idEmpleado,
            cantidad: 1
          })
        } else {
          platoProveedor.asignaciones = [{
            idEmpleado: options.idEmpleado,
            cantidad: 1
          }]
        }
      }
      let idx = _.findIndex(me.carrito, (item) => {
        return item.fecha === options.fecha
      })
      me.carrito.splice(idx, 1, itemCarrito)
    },
    onDesasignarPlatoProveedor (options) {
      const me = this
      let itemCarrito = me.existeDia(options.fecha)
      let proveedor = me.existeProveedorEnDia(itemCarrito, options.plato.proveedor)
      let platoProveedor = me.existePlatoEnProveedor(proveedor, options.plato)
      let asignacion = me.existeAsignacionEnPlato(platoProveedor, options.idEmpleado)
      if (asignacion.cantidad > 1) {
        asignacion.cantidad -= 1
      } else {
        let idxAsignacion = _.findIndex(platoProveedor.asignaciones, asignacion)
        platoProveedor.asignaciones.splice(idxAsignacion, 1)
      }
      let idx = _.findIndex(me.carrito, (item) => {
        return item.fecha === options.fecha
      })
      me.carrito.splice(idx, 1, itemCarrito)
    },
    onMostrarNotificacion (texto, tipo = 'success', ubicacion = 'topRight') {
      console.log('notificaciones', texto)
      new Noty({
        text: texto,
        type: tipo,
        timeout: 3000,
        layout: ubicacion
      }).show()
    },
    onPerfilChanged (data) {
      const me = this
      if (me.user) {
        console.log('onPerfilChanged', data)
        me.user.firstName = data.firstName
        me.user.lastName = data.lastName
        me.user.displayName = data.firstName + ' ' + data.lastName
        me.user.telefono = data.telefono
        me.user.aceptaMailing = data.aceptaMailing
        me.user.celiac = data.celiac
        me.user.vegan = data.vegan
        me.user.vegetarian = data.vegetarian
        me.user.alergic = data.alergic
        me.user.other = data.other
        me.user.restrictions = data.restrictions
        me.user.telefonoCelular = data.telefonoCelular
        me.user.notificarWhatsapp = data.notificarWhatsapp
        localforage.setItem('user', me.user).then(() => {})
      }
    },
    onTryLogout (id = null) {
      console.log('try-logout')
      Noty.closeAll()
      const me = this
      me.onVaciarCarrito()
      me.onCerrarCarrito()
      me.user = null
      localforage.setItem('user', null).then(() => {
        me.$router.push({
          path: '/'
        })
      })
    },
    onTryLogin (values) {
      console.log('values', values)
      const me = this
      this.$http.post('/api/users/login', values).then((response) => {
        me.user = response.body
        if (me.user.roles[0] === 'admincliente' || me.user.roles[0] === 'user') {
          me.$router.push({
            path: '/hacerpedido',
            props: {
              user: me.user
            }
          })
        }
        if (me.user.roles[0] === 'restaurante') {
          me.$router.push({
            path: '/gestorentregas'
          })
        }
      }, (error) => {
        console.log('err', error)
      })
    },
    onToggleCarrito () {
      this.mostrarCarrito = !this.mostrarCarrito
    },
    onUserLogged () {
      console.log('onUserLogged')
      const me = this
      me.$http.get('/api/users/me').then(({body}) => {
        me.user = body
        if (!body.notificarWhatsapp && !body.roles.includes('fruta') && !body.roles.includes('restaurante')) {
          new Noty({
            text: '<span class="pull-right clickeable"><i class="fa fa-times"></i> Cerrar</span><h4><b>No te olvides de realizar tus pedidos</b><br/><br/>Ahora podés recibir recordatorios vía <i class="fa fa-whatsapp"></i> Whatsapp, ingresa <a href="#/perfil">aquí</a> para configurarlos.</h4>',
            type: 'primary',
            layout: 'bottomRight'
          }).show()
        }
        localforage.setItem(`user`, me.user).then(() => {
          return me.user
        })
      }, (err) => {
        console.error(err)
      }).then((user) => {
        if (user) {
          localforage.getItem(`carrito-${user._id}`).then((carrito) => {
            if (carrito) {
              me.carrito = carrito
            }
          })
        }
        if (me.user.roles[0] === 'admincliente' || me.user.roles[0] === 'user') {
          if (!me.user.needsToAnswerCampaign) {
            me.$router.push({
              path: '/hacerpedido',
              props: {
                user: me.user
              }
            })
          } else {
            me.$router.push({
              path: '/campaign/answer',
              props: {
                user: me.user
              }
            })
          }
        }
        if (me.user.roles[0] === 'restaurante') {
          me.$router.push({
            path: '/gestorentregas'
          })
        }
        if (me.user.roles[0] === 'root') {
          me.$router.push({
            path: '/stats'
          })
        }
      })
    },
    onVaciarCarrito () {
      this.carrito = []
      // this.setCarritoStorage()
    },
    setCarritoStorage () {
      const user = this.user
      if (!user) return false
      localforage.setItem(`carrito-${user._id}`, this.carrito).then(function () {
        // console.log('user', `carrito-${user._id}`)
        return localforage.getItem(`carrito-${user._id}`)
      }).then((value) => {
      }).catch((err) => {
        console.warn(err)
      })
    }
  },
  created () {
    localforage.getItem(`user`).then((user) => {
      if (user) {
        this.user = user
      }
    })
    const me = this
    this.$http.get('/api/users/me').then((response) => {
      if (response.body === '') {
        return undefined
      } else {
        me.user = response.body
        return me.user
      }
    }, (error) => {
      console.log('error de la llamada', error)
    }).then((user) => {
      if (user) {
        localforage.getItem(`carrito-${user._id}`).then((carrito) => {
          if (carrito) {
            me.carrito = carrito
          }
        })
        if (user.needsToAnswerCampaign) {
          me.$router.push({
            path: '/campaign/answer',
            props: {
              user: me.user
            }
          })
        }
      } else {
        me.onVaciarCarrito()
        me.onCerrarCarrito()
        me.user = null
        console.log(me.$router.currentRoute.path)
        localforage.setItem('user', null).then(() => {
          if (me.$router.currentRoute.path.indexOf('/recuperar') !== -1 || me.$router.currentRoute.path.indexOf('/login') !== -1 || me.$router.currentRoute.path.indexOf('/suscripcion') !== -1 || me.$router.currentRoute.path.indexOf('/ondemand') !== -1 || me.$router.currentRoute.path.indexOf('/partners') !== -1) {
          } else {
            me.$router.push({
              path: '/'
            })
          }
        })
      }
    })
  },
  mounted () {
    $.fn.extend({
      animateCss: function (animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'
        this.addClass('animated ' + animationName).one(animationEnd, function () {
          $(this).removeClass('animated ' + animationName)
        })
      }
    })
  },
  watch: {
    carrito (newVal) {
      this.setCarritoStorage()
    }
  }
}
</script>
<style>
  footer.footer {
    top: 100px;
  }
  .pace {
    -webkit-pointer-events: none;
    pointer-events: none;

    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }

  .pace-inactive {
    display: none;
  }

  .pace .pace-progress {
    background: #29d;
    position: fixed;
    z-index: 2000;
    top: 0;
    right: 100%;
    width: 100%;
    height: 2px;
  }



.animation-target {
  -webkit-animation: animation 2800ms linear infinite both;
  animation: animation 2800ms linear infinite both;
}

/* Generated with Bounce.js. Edit at https://goo.gl/B1bNzi */

@-webkit-keyframes animation { 
  0% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -500, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -500, 0, 0, 1); }
  1.14% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.621, 1, 0, 0, 0, 0, 1, 0, -282.728, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.621, 1, 0, 0, 0, 0, 1, 0, -282.728, 0, 0, 1); }
  2.29% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.829, 1, 0, 0, 0, 0, 1, 0, -149.309, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.829, 1, 0, 0, 0, 0, 1, 0, -149.309, 0, 0, 1); }
  3.43% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.695, 1, 0, 0, 0, 0, 1, 0, -72.484, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.695, 1, 0, 0, 0, 0, 1, 0, -72.484, 0, 0, 1); }
  4.54% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.477, 1, 0, 0, 0, 0, 1, 0, -31.997, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.477, 1, 0, 0, 0, 0, 1, 0, -31.997, 0, 0, 1); }
  4.58% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.47, 1, 0, 0, 0, 0, 1, 0, -31.079, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.47, 1, 0, 0, 0, 0, 1, 0, -31.079, 0, 0, 1); }
  6.76% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.146, 1, 0, 0, 0, 0, 1, 0, -1.766, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.146, 1, 0, 0, 0, 0, 1, 0, -1.766, 0, 0, 1); }
  6.86% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.135, 1, 0, 0, 0, 0, 1, 0, -1.214, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.135, 1, 0, 0, 0, 0, 1, 0, -1.214, 0, 0, 1); }
  9.01% { -webkit-transform: matrix3d(1, 0, 0, 0, -0.003, 1, 0, 0, 0, 0, 1, 0, 2.88, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, -0.003, 1, 0, 0, 0, 0, 1, 0, 2.88, 0, 0, 1); }
  9.15% { -webkit-transform: matrix3d(1, 0, 0, 0, -0.007, 1, 0, 0, 0, 0, 1, 0, 2.886, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, -0.007, 1, 0, 0, 0, 0, 1, 0, 2.886, 0, 0, 1); }
  11.23% { -webkit-transform: matrix3d(1, 0, 0, 0, -0.033, 1, 0, 0, 0, 0, 1, 0, 1.99, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, -0.033, 1, 0, 0, 0, 0, 1, 0, 1.99, 0, 0, 1); }
  20.16% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.002, 1, 0, 0, 0, 0, 1, 0, 0.01, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.002, 1, 0, 0, 0, 0, 1, 0, 0.01, 0, 0, 1); }
  23.45% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.001, 1, 0, 0, 0, 0, 1, 0, -0.003, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.001, 1, 0, 0, 0, 0, 1, 0, -0.003, 0, 0, 1); }
  28.47% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); }
  28.57% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); }
  29.1% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -7.992, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -7.992, 0, 1); }
  29.86% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -15.312, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -15.312, 0, 1); }
  31.15% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -19.275, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -19.275, 0, 1); }
  32.75% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -15.606, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -15.606, 0, 1); }
  34.33% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -9.111, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -9.111, 0, 1); }
  35.71% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -4.058, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -4.058, 0, 1); }
  35.94% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -3.395, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -3.395, 0, 1); }
  37.51% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.013, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.013, 0, 1); }
  40.08% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -1.622, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -1.622, 0, 1); }
  46.45% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); }
  49.02% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.137, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.137, 0, 1); }
  55.38% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  57.96% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.011, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.011, 0, 1); }
  62.4% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.003, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.003, 0, 1); }
  62.5% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); }
  64.04% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.375, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.375, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  64.19% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.41, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.41, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  64.29% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  64.29% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  65.57% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.704, 1, 0, 0, 0, 0, 1, 0, 218.852, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.704, 1, 0, 0, 0, 0, 1, 0, 218.852, 0, 0, 1); }
  65.82% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.747, 1, 0, 0, 0, 0, 1, 0, 257.135, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.747, 1, 0, 0, 0, 0, 1, 0, 257.135, 0, 0, 1); }
  67.11% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.903, 1, 0, 0, 0, 0, 1, 0, 416.676, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.903, 1, 0, 0, 0, 0, 1, 0, 416.676, 0, 0, 1); }
  67.36% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.921, 1, 0, 0, 0, 0, 1, 0, 439.293, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.921, 1, 0, 0, 0, 0, 1, 0, 439.293, 0, 0, 1); }
  68.65% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.957, 1, 0, 0, 0, 0, 1, 0, 517.583, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.957, 1, 0, 0, 0, 0, 1, 0, 517.583, 0, 0, 1); }
  68.9% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.956, 1, 0, 0, 0, 0, 1, 0, 526.138, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.956, 1, 0, 0, 0, 0, 1, 0, 526.138, 0, 0, 1); }
  70.43% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.922, 1, 0, 0, 0, 0, 1, 0, 546.667, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.922, 1, 0, 0, 0, 0, 1, 0, 546.667, 0, 0, 1); }
  72.62% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.864, 1, 0, 0, 0, 0, 1, 0, 528.816, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.864, 1, 0, 0, 0, 0, 1, 0, 528.816, 0, 0, 1); }
  74.4% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 510.313, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 510.313, 0, 0, 1); }
  76.59% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.832, 1, 0, 0, 0, 0, 1, 0, 498.826, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.832, 1, 0, 0, 0, 0, 1, 0, 498.826, 0, 0, 1); }
  78.37% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.834, 1, 0, 0, 0, 0, 1, 0, 496.885, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.834, 1, 0, 0, 0, 0, 1, 0, 496.885, 0, 0, 1); }
  84.52% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.84, 1, 0, 0, 0, 0, 1, 0, 500.078, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.84, 1, 0, 0, 0, 0, 1, 0, 500.078, 0, 0, 1); }
  86.31% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500.208, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500.208, 0, 0, 1); }
  92.49% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.994, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.994, 0, 0, 1); }
  94.28% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.986, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.986, 0, 0, 1); }
  98.21% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.997, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.997, 0, 0, 1); }
  100% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500, 0, 0, 1); } 
}

@keyframes animation { 
  0% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -500, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -500, 0, 0, 1); }
  1.14% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.621, 1, 0, 0, 0, 0, 1, 0, -282.728, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.621, 1, 0, 0, 0, 0, 1, 0, -282.728, 0, 0, 1); }
  2.29% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.829, 1, 0, 0, 0, 0, 1, 0, -149.309, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.829, 1, 0, 0, 0, 0, 1, 0, -149.309, 0, 0, 1); }
  3.43% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.695, 1, 0, 0, 0, 0, 1, 0, -72.484, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.695, 1, 0, 0, 0, 0, 1, 0, -72.484, 0, 0, 1); }
  4.54% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.477, 1, 0, 0, 0, 0, 1, 0, -31.997, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.477, 1, 0, 0, 0, 0, 1, 0, -31.997, 0, 0, 1); }
  4.58% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.47, 1, 0, 0, 0, 0, 1, 0, -31.079, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.47, 1, 0, 0, 0, 0, 1, 0, -31.079, 0, 0, 1); }
  6.76% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.146, 1, 0, 0, 0, 0, 1, 0, -1.766, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.146, 1, 0, 0, 0, 0, 1, 0, -1.766, 0, 0, 1); }
  6.86% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.135, 1, 0, 0, 0, 0, 1, 0, -1.214, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.135, 1, 0, 0, 0, 0, 1, 0, -1.214, 0, 0, 1); }
  9.01% { -webkit-transform: matrix3d(1, 0, 0, 0, -0.003, 1, 0, 0, 0, 0, 1, 0, 2.88, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, -0.003, 1, 0, 0, 0, 0, 1, 0, 2.88, 0, 0, 1); }
  9.15% { -webkit-transform: matrix3d(1, 0, 0, 0, -0.007, 1, 0, 0, 0, 0, 1, 0, 2.886, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, -0.007, 1, 0, 0, 0, 0, 1, 0, 2.886, 0, 0, 1); }
  11.23% { -webkit-transform: matrix3d(1, 0, 0, 0, -0.033, 1, 0, 0, 0, 0, 1, 0, 1.99, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, -0.033, 1, 0, 0, 0, 0, 1, 0, 1.99, 0, 0, 1); }
  20.16% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.002, 1, 0, 0, 0, 0, 1, 0, 0.01, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.002, 1, 0, 0, 0, 0, 1, 0, 0.01, 0, 0, 1); }
  23.45% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.001, 1, 0, 0, 0, 0, 1, 0, -0.003, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.001, 1, 0, 0, 0, 0, 1, 0, -0.003, 0, 0, 1); }
  28.47% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); }
  28.57% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.001, 0, 0, 1); }
  29.1% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -7.992, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -7.992, 0, 1); }
  29.86% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -15.312, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -15.312, 0, 1); }
  31.15% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -19.275, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.001, -19.275, 0, 1); }
  32.75% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -15.606, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -15.606, 0, 1); }
  34.33% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -9.111, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -9.111, 0, 1); }
  35.71% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -4.058, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -4.058, 0, 1); }
  35.94% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -3.395, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -3.395, 0, 1); }
  37.51% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.013, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.013, 0, 1); }
  40.08% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -1.622, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -1.622, 0, 1); }
  46.45% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); }
  49.02% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.137, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.137, 0, 1); }
  55.38% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  57.96% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.011, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.011, 0, 1); }
  62.4% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.003, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.003, 0, 1); }
  62.5% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -0.002, 0, 1); }
  64.04% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.375, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.375, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  64.19% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.41, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.41, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  64.29% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  64.29% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.434, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  65.57% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.704, 1, 0, 0, 0, 0, 1, 0, 218.852, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.704, 1, 0, 0, 0, 0, 1, 0, 218.852, 0, 0, 1); }
  65.82% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.747, 1, 0, 0, 0, 0, 1, 0, 257.135, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.747, 1, 0, 0, 0, 0, 1, 0, 257.135, 0, 0, 1); }
  67.11% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.903, 1, 0, 0, 0, 0, 1, 0, 416.676, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.903, 1, 0, 0, 0, 0, 1, 0, 416.676, 0, 0, 1); }
  67.36% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.921, 1, 0, 0, 0, 0, 1, 0, 439.293, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.921, 1, 0, 0, 0, 0, 1, 0, 439.293, 0, 0, 1); }
  68.65% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.957, 1, 0, 0, 0, 0, 1, 0, 517.583, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.957, 1, 0, 0, 0, 0, 1, 0, 517.583, 0, 0, 1); }
  68.9% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.956, 1, 0, 0, 0, 0, 1, 0, 526.138, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.956, 1, 0, 0, 0, 0, 1, 0, 526.138, 0, 0, 1); }
  70.43% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.922, 1, 0, 0, 0, 0, 1, 0, 546.667, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.922, 1, 0, 0, 0, 0, 1, 0, 546.667, 0, 0, 1); }
  72.62% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.864, 1, 0, 0, 0, 0, 1, 0, 528.816, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.864, 1, 0, 0, 0, 0, 1, 0, 528.816, 0, 0, 1); }
  74.4% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 510.313, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 510.313, 0, 0, 1); }
  76.59% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.832, 1, 0, 0, 0, 0, 1, 0, 498.826, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.832, 1, 0, 0, 0, 0, 1, 0, 498.826, 0, 0, 1); }
  78.37% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.834, 1, 0, 0, 0, 0, 1, 0, 496.885, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.834, 1, 0, 0, 0, 0, 1, 0, 496.885, 0, 0, 1); }
  84.52% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.84, 1, 0, 0, 0, 0, 1, 0, 500.078, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.84, 1, 0, 0, 0, 0, 1, 0, 500.078, 0, 0, 1); }
  86.31% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500.208, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500.208, 0, 0, 1); }
  92.49% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.994, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.994, 0, 0, 1); }
  94.28% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.986, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.986, 0, 0, 1); }
  98.21% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.997, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 499.997, 0, 0, 1); }
  100% { -webkit-transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0.839, 1, 0, 0, 0, 0, 1, 0, 500, 0, 0, 1); } 
}


</style>




// WEBPACK FOOTER //
// App.vue?b35b0074